/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Select_Event_NumberInputs */



/**
* | output |
* | --- |
* | "Select event number" |
*
* @param {Editor_Select_Event_NumberInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_select_event_number = /** @type {((inputs?: Editor_Select_Event_NumberInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Select_Event_NumberInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner le numero d'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisnummer auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il numero dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите номер мероприятия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el número de evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择事件编号")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント番号を選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट नंबर चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o número do evento")
	return /** @type {LocalizedString} */ ("Select event number")
});